import { HREmpMultipleDoc } from './hrEmpMultipleDocs';

export class HrEmpPreviousEmploymentDetails {
  Id: number;
  EmpCode: number;
  CompanyName: string;
  Designation: string;
  FromDate: Date;
  ToDate: Date;
  JobLocation: string;
  CreatedBy: string;
  CreatedDate: Date;
  ModifiedBy: string;
  ModifiedDate: Date;
  HREmpDocs: HREmpMultipleDoc[];

}

export class EmpPreviousEmploymentDetails {
  PriorExperienceYears: number;
  PriorExperienceMonths: number;
  hrEmpPreviousEmploymentDtls: HrEmpPreviousEmploymentDetails[];
}
